import React from "react";   
import SectionTitle from "../SectionTitles/SectionTitle";
import EstimateForm from './EstimateForm'
 


const Estimate = () => {
  return (
	<section 
    className="free-estimate" id="quote" >
	    <div className="container"> 
			<div className="row">  
				<div className="col-md-8 col-sm-12 why_chs">
					{/* Heading */}
					<SectionTitle
						title="Get A Fast And Free Quote"
					/>
					{/* End: Heading */}

					{/*Start:   About List */} 
					<div className="col-sm-12">
                          <EstimateForm />
                    </div>
					{/*End:  About List*/}

				</div> 
			</div> 
        </div> 
	</section>  

  );
};

export default Estimate;
